<template>
  <div class="login-layout blur-login">
  <div class="main-container">
    <div class="main-content">
      <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
      <div class="row">
        <div class="col-sm-10 col-sm-offset-1">
          <div class="login-container">
            <div class="position-relative">
              <div id="forgot-box" class="forgot-box visible widget-box no-border">
                <template v-if="sucessStatus === true">
                  <div class="widget-body">
                    <div class="widget-main">
                      <h4 class="header red lighter bigger">
                        <i class="ace-icon fa fa-key"></i>
                        パスワード再発行
                      </h4>
                      <div class="space-6"></div>
                      <div class="alert alert-success">
                        {{ message }}
                      </div>
                    </div><!-- /.widget-main -->

                    <div class="toolbar center">
                      <router-link tag="a" :to="{ name: 'login'}" class="back-to-login-link">
                        <i class="ace-icon fa fa-arrow-right"></i>
                        ログインページに戻る
                      </router-link>
                    </div>
                  </div><!-- /.widget-body -->
                </template>
                <template v-else>
                  <div class="widget-body">
                    <div class="widget-main">
                      <h4 class="header red lighter bigger">
                        <i class="ace-icon fa fa-key"></i>
                        パスワード再発行
                      </h4>
                      <div class="space-6"></div>
                      <div class="alert alert-danger" v-if="error === true">
                        {{ message }}
                      </div>
                      <form @submit.prevent="validateBeforeSubmit">
                        <fieldset>
                          <label class="block clearfix">
                            <span v-show="errors.has('ownerId')" class="error">{{ errors.first('ownerId') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('ownerId') }" name="ownerId" type="text" class="form-control" v-validate="'required'"  placeholder="事業者ID" v-model="credentials.ownerId"/>
                              <i class="ace-icon fa fa-user"></i>
                            </span>
                          </label>
                          <label class="block clearfix">
                            <span v-show="errors.has('userId')" class="error">{{ errors.first('userId') }}</span>
                            <span class="block input-icon input-icon-right">
                              <input :class="{ error: errors.has('userId') }" v-validate="'required'" name="userId" type="text" class="form-control" placeholder="ユーザーID" v-model="credentials.userId"/>
                              <i class="ace-icon fa fa-user"></i>
                            </span>
                          </label>
                          <div class="clearfix">
                            <button type="submit" class="width-100 pull-right btn btn-sm btn-danger">
                              <span class="bigger-110">送信</span>
                            </button>
                          </div>
                        </fieldset>
                      </form>
                    </div><!-- /.widget-main -->

                    <div class="toolbar center">
                      <router-link tag="a" :to="{ name: 'login'}" class="back-to-login-link">
                        <i class="ace-icon fa fa-arrow-right"></i>
                        ログインページに戻る
                      </router-link>
                    </div>
                  </div><!-- /.widget-body -->
                </template>
              </div><!-- /.forgot-box -->
            </div><!-- /.position-relative -->
          </div>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div><!-- /.main-container -->
  </div>
</template>

<script>
import * as Config from '../../config'

export default {
  data () {
    return {
      credentials: {
        ownerId: '',
        userId: ''
      },
      loading: false,
      sucessStatus: false,
      error: false,
      message: ''
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true
          const credentials = {
            ownerId: this.credentials.ownerId,
            userId: this.credentials.userId
          }
          this.$http.post(Config.FORGOT_PASSWORD_API, JSON.stringify(credentials))
            .then(response => {
              if (response.body.message === 'Success') {
                this.sucessStatus = true
                this.loading = false
                // this.message = Config.FORGOT_API_SUCCESS_SEND_RESET_CODE
                // owserIdとuserIdの値をlocalstorageに保存する
                localStorage.setItem('ownerId', this.credentials.ownerId)
                localStorage.setItem('userId', this.credentials.userId)
                this.$router.push({name: 'resetpassword'})
              }
            })
            .catch((error) => {
              this.loading = false
              if (error.body) {
                this.error = true
                switch (error.status) {
                  case 400:
                    this.message = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                    break
                  case 404:
                    this.message = '該当するデーターがありません。'
                    break
                  case 500:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                  case 503:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                  default:
                    this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                    break
                }
              } else {
                this.error = true
                this.message = Config.SERVER_CONNECT_ERROR
              }
            })
        }
      })
    }
  }
}
</script>

<style>
body{
  background: #394557
}
span.error {
  color: red;
}
input {
  border: 1px solid black;
}
input.error {
  border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/views/login/ForgotPassword.vue